// extracted by mini-css-extract-plugin
export default {"row":"ChatMessageReactionItemPopoverContent_row__s1x6X"};